import { Check } from '../components';

var Home =()=>{
	return <Check />;
};

export default Home;
